import './Upcoming.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils, faDna, faBuilding } from '@fortawesome/free-solid-svg-icons';

const upcomingVentures = [
  {
    icon: faUtensils,
    category: "Modern F&B Experience",
    tagline: "A Smarter Approach to Dining",
    paragraphs: [
      "A next-generation food and beverage investment built around a more intelligent, modern approach to hospitality.",
      "This concept is being developed at the intersection of culinary relevance, operational efficiency, food technology, and elevated customer experience — responding to the evolving expectations of today's consumers with a sharper, more scalable model for tomorrow's market.",
      "From smarter service flows and contemporary formats to trend-aware product design and experience-led execution, this investment is intended to reflect where food and beverage is heading, not where it has been.",
    ],
  },
  {
    icon: faDna,
    category: "Health, Wellness & Human Enhancement",
    tagline: "Developing the Next Generation of Science-Led Supplements",
    paragraphs: [
      "A new consumer health brand under development, focused on advanced food supplement solutions designed to support wellbeing, longevity, and everyday performance.",
      "Built on science-led formulation principles and guided by internationally recognized scientific expertise, the brand aims to bridge credible research with accessible daily health products.",
      "Our vision is to create a trusted supplement platform where wellness is approached with greater intelligence, depth, and purpose.",
    ],
  },
  {
    icon: faBuilding,
    category: "Lifestyle-Oriented Developments",
    tagline: "Shaping the Future of Modern Living",
    paragraphs: [
      "Our upcoming real estate venture marks our entry into lifestyle-oriented developments, focused on creating environments that blend modern living, design, and human experience.",
      "Moving beyond traditional real estate, this initiative explores how spaces can be designed to enhance daily life, foster community, and integrate seamlessly with evolving consumer behaviors.",
      "Positioned at the intersection of development, experience, and long-term value creation, this venture reflects our commitment to building assets that are both relevant today and resilient for the future.",
    ],
  },
];

function Upcoming() {
  return (
    <div id="upcoming">
      <div className="upcoming-container">
        <div className="upcoming-header">
          <h1>Upcoming Investments</h1>
          <p className="upcoming-subtitle">Building What's Next</p>
          <p className="upcoming-intro">
            We are actively developing and preparing a new wave of investments
            centered around the future of consumer experience, modern living,
            and human wellbeing.
          </p>
          <p className="upcoming-intro">
            These upcoming ventures reflect our commitment to backing ideas that
            do more than enter markets — they aim to reshape them through
            innovation, relevance, and long-term value creation.
          </p>
        </div>

        <div className="upcoming-ventures">
          {upcomingVentures.map((venture, index) => (
            <div className="upcoming-venture" key={index}>
              <div className="upcoming-venture-accent">
                <FontAwesomeIcon icon={venture.icon} className="upcoming-venture-icon" />
              </div>
              <div className="upcoming-venture-content">
                <h2>{venture.category}</h2>
                <h3>{venture.tagline}</h3>
                {venture.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Upcoming;
